export default __webpack_public_path__ + "static/media/default_bg.b51172af.png";